/**
 * Types of labels and lists that can be found in the questionnaire
 */
export enum LabelType {
  QUESTION = "Question Label",
  LIST = "List",
  RANGE_LIST = "Range List",
  EXCEPTIONS = "Exceptions",
}

/**
 * Represents a label or list found in the questionnaire
 */
export interface LabelItem {
  /** Unique identifier for the label/list */
  id: string
  /** The type of label/list */
  type: LabelType
  /** The name/identifier of the label/list */
  name: string
  /** The content of the label/list (for lists, this includes all items) */
  content: string
  /** Line numbers where this label/list appears in the questionnaire */
  lineNumbers: number[]
  /** The original line text (for reference) */
  originalLines: string[]
  /** For lists: line numbers where this list is referenced (used in PER or FROM) */
  referenceLineNumbers?: number[]
  /** For lists: the original lines where this list is referenced */
  referenceLines?: string[]
}
